import Api from "../Utils/Axios";

export const GetConversationRate = async (params = {}) => {
    const response = await Api.get("report/conversion-rate", { params });
    return response.data;
};

export const GetUserAgeGroupCount = async (params = {}) => {
    const response = await Api.get("report/age-group-count", { params });
    return response.data;
};
